export const ADS_VENDOR_LINKS_QUERY_KEY = ['ads-vendor-links'] as const;
